import { c as _c } from "react/compiler-runtime";
import { ElementType, ReactNode } from 'react';
import HelpIcon from '@mui/icons-material/Help';
import { SxProps, Theme, styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import Tooltip from '@classify/react-core-components/Tooltip';
import Stack from '@classify/react-core-components/Stack';
import { palette } from '@classify/react-core-components/Theme';
export interface Props {
  sx?: SxProps<Theme>;
  accessibilityLabel?: string;
  children: ReactNode;
  overTitle?: string;
  tooltipContent?: string;
  icon?: ElementType<any>;
  shouldNotWrap?: boolean;
}
const Root = styled(Box)({
  color: 'inherit',
  display: 'flex',
  alignItems: 'flex-start',
  wordBreak: 'keep-all'
});
const ProductMetadata = t0 => {
  const $ = _c(25);
  const {
    sx,
    children,
    icon: MetaDataIcon,
    accessibilityLabel,
    overTitle,
    tooltipContent,
    shouldNotWrap: t1
  } = t0;
  const shouldNotWrap = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== MetaDataIcon || $[1] !== accessibilityLabel || $[2] !== overTitle) {
    t2 = MetaDataIcon && <MetaDataIcon titleAccess={accessibilityLabel} sx={{
      height: "18px",
      width: "18px",
      verticalAlign: "middle",
      marginRight: overTitle ? 2 : 1,
      marginTop: overTitle ? 0 : "2px"
    }} />;
    $[0] = MetaDataIcon;
    $[1] = accessibilityLabel;
    $[2] = overTitle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== overTitle) {
    t3 = overTitle && <Typography variant="overline" sx={{
      color: palette.text.onMainMinor
    }}>{overTitle}</Typography>;
    $[4] = overTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== shouldNotWrap) {
    t4 = shouldNotWrap && {
      whiteSpace: "nowrap"
    };
    $[6] = shouldNotWrap;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      ...t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t5) {
    t6 = <Typography variant="bodySmall" sx={t5}>{children}</Typography>;
    $[10] = children;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== tooltipContent) {
    t7 = tooltipContent && <Tooltip content={tooltipContent} placement="bottom-start"><HelpIcon sx={{
        color: palette.background.question,
        width: 16,
        height: 16
      }} /></Tooltip>;
    $[13] = tooltipContent;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Stack direction="row" alignItems="center" gap={0.5}>{t6}{t7}</Stack>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t8) {
    t9 = <Stack>{t3}{t8}</Stack>;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== sx || $[22] !== t2 || $[23] !== t9) {
    t10 = <Root sx={sx}>{t2}{t9}</Root>;
    $[21] = sx;
    $[22] = t2;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default ProductMetadata;